import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import axios from "../common/axios";
import ListItemTestResult from "../common/ListItemTestResult";
import ShortcutLink from "../common/ShortcutLink";
import {UserContext} from "../common/UserContext";
import useCurrentShortcut from "../hooks/useCurrentShortcut";

const TeacherTestResultsDashboardWidget = props => {
    const [classesProps, setClassesProps] = useState([]);
    const [classId, setClassId] = useState();
    const [testResults, setTestResults] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const {user, setUser} = useContext(UserContext);
    const {loadShortcutByUrl} = useCurrentShortcut();

    useEffect(() => {
        const currentClass = user.classes.findIndex(clazz => clazz.classId == user.classId);
        let newClassesProps = {
            defaultSelected: currentClass == -1 ? 0 : currentClass,
            options: []
        };
        user.classes.map(clazz => {
            let option = {
                value: clazz.classId,
                label: clazz.className
            }
            newClassesProps.options.push(option);
        });
        setClassesProps(newClassesProps);
    }, [user.classes]);

    useEffect(() => {
        setLoading(true);
        if (classId !== undefined) {
            axios.get('/web/ui/test/classResults/' + classId)
                .then(response => {
                    setTestResults(response.data);
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, [classId]);

    const handleChange = selectedOption => {
        setClassId(selectedOption.value);
    }

    const createTestFromDashBoard = () => {
        globalReactFunctions.createTestFromDashboard = true;
        loadShortcutByUrl('/web/ui/view/teacherAssessments');
    }

    return (
        <DashboardWidget
            title={
                <>
                    <svg className="ch-icon-sm" viewBox="0 0 128 128">
                        <use href="#tests-icon"></use>
                    </svg>
                    <ShortcutLink className="ch-highlight" shortcutUrl={'/web/ui/view/teacherAssessments'}>
                        <span>Test Results</span>
                    </ShortcutLink>
                </>
            }
            isLoading={isLoading}
            headerObjects={[{componentName: 'Button', otherProps: {size: 'small', children: 'Create test', onClick: createTestFromDashBoard}},
                {componentName: 'ButtonSelect', otherProps: {position: 'right', options: classesProps.options, title: 'Class', value: classesProps.defaultSelected !== undefined ? classesProps.options[classesProps.defaultSelected] : '', onChange: handleChange}}]}
        >
            <div className={'ch-dashboard-blk-body'}>
                {testResults.length > 0 &&
                    <table style={{width: '100%'}} className={'ch-dashboard-list ch-list'}>
                        <tbody>
                            <tr>
                                <th>Test and Student</th>
                                <th style={{width: '60%'}}>
                                    Results
                                </th>
                                <th style={{width: '60px'}}>Score</th>
                                <th style={{width: '60px'}}>Percent</th>
                            </tr>
                            {testResults.map((testResult, index) => (
                                <ListItemTestResult key={index} testResult={testResult} timeZone={user.timeZone} />
                            ))}
                        </tbody>
                    </table>
                }
                {testResults.length == 0 &&
                    <div className="ch-list-item-disabled">No test results</div>
                }
            </div>
        </DashboardWidget>
    )
}

export default TeacherTestResultsDashboardWidget;